import { CurrencyDisplay } from "components";
import { Box, Grid, Skeleton, Typography } from "@mui/material";
import { Divider } from "@material-ui/core";

const InformationTable = ({ pageDetail, isLoadiing, skeletonHeight = 100 }) => {
  return isLoadiing ? (
    <Skeleton
      variant="rounded"
      height={skeletonHeight}
      animation="wave"
      width={500}
    />
  ) : (
    <Box
      border="solid 1px #e0e0e0"
      borderRadius={2}
      width={500}
      overflow="hidden"
    >
      <ClaimRow
        label="Total Potential Claim"
        revenue={pageDetail?.total_potential_claim?.total_revenue}
        records={pageDetail?.total_potential_claim?.total_records}
      />
      <Divider />
      <ClaimRow
        label="Potential Claimed"
        revenue={pageDetail?.potential_claimed?.total_revenue}
        records={pageDetail?.potential_claimed?.total_records}
      />
    </Box>
  );
};
const ClaimRow = ({ label, revenue, records }) => {
  return (
    <Box display="flex" justifyContent="space-between" p="12px 16px">
      <Typography fontWeight={600}>{label}</Typography>
      <Typography>
        <Grid container columnGap={1}>
          <Grid item>
            <CurrencyDisplay value={revenue || 0} prefix="Rp" />
          </Grid>
          <Grid item>/</Grid>
          <Grid item>
            <CurrencyDisplay value={records || 0} suffix=" Row" />
          </Grid>
        </Grid>
      </Typography>
    </Box>
  );
};
export default InformationTable;
